import { useDragger } from '../../../hooks/region';
import React, { memo, useRef } from 'react';
import { usePrefixCls } from '@byte-design/config';
export var ColorDragger = memo(function (props) {
  var name = props.name,
      _props$draggable = props.draggable,
      draggable = _props$draggable === void 0 ? false : _props$draggable,
      _props$dimension = props.dimension,
      dimension = _props$dimension === void 0 ? 'one' : _props$dimension;
  var elemRef = useRef(null);

  var _useDragger = useDragger(elemRef, name, draggable),
      offset = _useDragger.offset;

  var cls = usePrefixCls('color-slider-dragger');
  return React.createElement("div", {
    ref: elemRef,
    className: cls,
    style: {
      left: "".concat(offset.x, "px"),
      top: dimension === 'two' ? "".concat(offset.y, "px") : undefined
    }
  });
});